/// VariableTree: Recursive tree view for nested variable objects.
/// Renders each key-value pair as a VariableNode, supporting expansion
/// into nested objects and arrays.

import { VariableNode } from "./VariableNode";

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

interface VariableTreeProps {
  data: Record<string, unknown>;
  path?: string;
}

export function VariableTree({ data, path = "" }: VariableTreeProps) {
  const entries = Object.entries(data);

  if (entries.length === 0) {
    return <div className="px-2 py-1 text-xs text-zinc-500 italic">(empty)</div>;
  }

  return (
    <div className="flex flex-col">
      {entries.map(([key, value]) => (
        <VariableNode
          key={`${path}.${key}`}
          name={key}
          value={value}
          path={path ? `${path}.${key}` : key}
        />
      ))}
    </div>
  );
}
